<div class="colisPanel row">
    <span>
       <img src='{{richText.image1Url}}' class="imgCircle">  
       <img src='{{richText.image2Url}}' class="imgColis">
      </span>
</div>